import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantYourShopPage } from './merchant-your-shop';

@NgModule({
  declarations: [
    MerchantYourShopPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantYourShopPage),
    TranslateModule.forChild()
  ],
})
export class MerchantYourShopPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-your-shop/merchant-your-shop.module.ts